import { RoutePath } from '@/core/router/route-paths';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { SideNav } from '..';
import {
  AutomationsIcon,
  BusinessAreasIcon,
  CompaniesIcon,
  InfrastructureIcon,
  OrganizationsIcon,
  ProcessesIcon,
  UserIcon,
} from '../Icons';

export const SideNavigation = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <div>
      <SideNav
        items={[
          {
            to: RoutePath.organizations(),
            label: t('organizations'),
            icon: OrganizationsIcon,
          },
          {
            to: RoutePath.companies(),
            label: t('companies'),
            icon: CompaniesIcon,
          },
          {
            to: RoutePath.businessAreas(),
            label: t('business_areas'),
            icon: BusinessAreasIcon,
          },
          {
            to: RoutePath.users(),
            label: t('users'),
            icon: UserIcon,
          },
          {
            to: RoutePath.processes(),
            label: t('processes'),
            icon: ProcessesIcon,
          },
          {
            to: RoutePath.automations(),
            label: t('automations'),
            icon: AutomationsIcon,
          },
          {
            to: RoutePath.infrastructureCosts(),
            label: t('infrastructure_costs'),
            icon: InfrastructureIcon,
          },
        ]}
      />
    </div>
  );
};
